import 'css-chunksrc/client/scenes/folderUpdate/styles.scss';export default {
  "updateFolder": "_updateFolder_rsurn_1",
  "main": "_main_rsurn_8",
  "buttons": "_buttons_rsurn_20"
};